function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { BaseWalletAdapter, LoginStateEnum, PORTKEY_ORIGIN_CHAIN_ID_KEY, makeError, ERR_CODE, ConnectedWallet, enhancedLocalStorage, LoginStatusEnum } from '@aelf-web-login/wallet-adapter-base';
import { did, managerApprove, getChain } from '@portkey/did-ui-react';
import { aes } from '@portkey/utils';
import { getContractBasic } from '@portkey/contracts';
export var PortkeyAAName = 'PortkeyAA';
export var PortkeyAAWallet = /*#__PURE__*/function (_BaseWalletAdapter) {
  _inherits(PortkeyAAWallet, _BaseWalletAdapter);
  var _super = _createSuper(PortkeyAAWallet);
  function PortkeyAAWallet(config) {
    var _this;
    _classCallCheck(this, PortkeyAAWallet);
    _this = _super.call(this);
    _defineProperty(_assertThisInitialized(_this), "name", PortkeyAAName);
    _defineProperty(_assertThisInitialized(_this), "icon", 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzFGMUYyMSIgZD0iTTcuNjI5IDMuMzY4Yy0xLjU3Mi42ODktMi43MSAyLjU1OS0yLjE1IDQuNjM1LjM5NCAxLjE0OCAxLjE0NSAxLjk3NiAyLjMyMyAyLjM5NSAyLjA2MS43MzEgNC4yNDgtLjkgMy45MzUtMi45OTItLjEzMy0uODktLjcwNC0xLjQ3Ny0xLjQ4Ni0xLjY5NS0uNjY4LS4xNTYtMS4zNDMtLjA0LTEuODI5LjQyNGExLjUwNCAxLjUwNCAwIDAgMC0uNDI4IDEuMzczYy4xLjMzLjI2LjUzNi42NjYuNjM0LjIyNC4wNTQuNTEgMCAuNTk4LS4yMDIuMDU5LS4xMzcuMDA0LS4yNS0uMDM3LS4zNzktLjExLS4zNTMtLjAzOC0uNTU2LjE1NC0uNzMuMjU5LS4yNTcuNjk4LS4yNi45NzYtLjA2NC4zNTkuMTgzLjY0NC43NjcuMzA4IDEuNjY0LS4zODQuOTI0LTEuMzg1IDEuMjAyLTIuMzE4Ljk2LTEuMzUtLjM1LTIuMDg1LTEuODgzLTEuNzYyLTMuMTAyLjUzOC0yLjAyOSAyLjc5OS0yLjY1NyA0LjY3OS0xLjcyNiAxLjI2OS43MTUgMi4wNjMgMS44NjcgMi4wNCAzLjQzMy0uMSAyLjU3NS0yLjcwNCA0LjQ3NC01LjMxIDMuOTc3YTUuMjc5IDUuMjc5IDAgMCAxLTQuMjItNS4wMzMgNS40MjcgNS40MjcgMCAwIDEgLjU3NC0yLjUzNkM1LjM2NCAyLjQ3NCA3LjE0IDEuNTcgOS40IDEuNDM0Yy41OTMtLjAzNSAxLjAyMyAwIDEuNzczLjA3NS0uMDMtLjAxNC0uMS0uMDQ3LS4xNzEtLjA3NGE2LjYzNSA2LjYzNSAwIDAgMC0zLjMwOS0uMzY3IDYuNjkgNi42OSAwIDAgMC0xLjkxNS41ODRjLS4yNTQuMDktLjI5Mi0uMTI2LS40ODgtLjI5LS4wOTItLjA3Ni0uMDgzLjAyLS4wODMuMDIuMDguMzgxLS4wOTcuNTczLS4xMjQuNTkyYTIuMDc5IDIuMDc5IDAgMCAxLS40ODIuMzMyYy0uMzI2LjE0Mi0uNDc4LS4wOTItLjczNy0uMjI1LS4xNzgtLjA5LS4xMDguMDYtLjEwOC4wNi4yMi40MzcuMDY2LjgzOS4wMy45MDItLjE1Mi4yMi0uMjc4LjM3NS0uNDgzLjU2LS4zNTkuMzI1LS43ODUuMDEyLS45MTItLjAzNi0uMjQtLjA4OS0uMDY3LjExNS0uMDY3LjExNS4wOTYuMTI3LjQ0Ljg1Ni4zMzMgMS4wODZhNi43MzcgNi43MzcgMCAwIDAtLjUzOSA0LjE2NWMxIDUuMDA0IDYuNjg4IDYuNzQgMTAuMjI4IDQuMzIxIDEuODc5LTEuMzg3IDIuNTItMy41NDggMi41NC00Ljg5NS4wMjItMS4zNDctLjMxNy0yLjMyNy0uOTQyLTMuMjAxLTEuNDg0LTIuMDc0LTQuMTY4LTIuNzMyLTYuMzE0LTEuNzlaIi8+PC9zdmc+');
    _defineProperty(_assertThisInitialized(_this), "darkIcon", 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTcuNjI5IDMuMzY4Yy0xLjU3Mi42ODktMi43MSAyLjU1OS0yLjE1IDQuNjM1LjM5NCAxLjE0OCAxLjE0NSAxLjk3NiAyLjMyMyAyLjM5NSAyLjA2MS43MzEgNC4yNDgtLjkgMy45MzUtMi45OTItLjEzMy0uODktLjcwNC0xLjQ3Ny0xLjQ4Ni0xLjY5NS0uNjY4LS4xNTYtMS4zNDMtLjA0LTEuODI5LjQyNGExLjUwNCAxLjUwNCAwIDAgMC0uNDI4IDEuMzczYy4xLjMzLjI2LjUzNi42NjYuNjM0LjIyNC4wNTQuNTEgMCAuNTk4LS4yMDIuMDU5LS4xMzcuMDA0LS4yNS0uMDM3LS4zNzktLjExLS4zNTMtLjAzOC0uNTU2LjE1NC0uNzMuMjU5LS4yNTcuNjk4LS4yNi45NzYtLjA2NC4zNTkuMTgzLjY0NC43NjcuMzA4IDEuNjY0LS4zODQuOTI0LTEuMzg1IDEuMjAyLTIuMzE4Ljk2LTEuMzUtLjM1LTIuMDg1LTEuODgzLTEuNzYyLTMuMTAyLjUzOC0yLjAyOSAyLjc5OS0yLjY1NyA0LjY3OS0xLjcyNiAxLjI2OS43MTUgMi4wNjMgMS44NjcgMi4wNCAzLjQzMy0uMSAyLjU3NS0yLjcwNCA0LjQ3NC01LjMxIDMuOTc3YTUuMjc5IDUuMjc5IDAgMCAxLTQuMjItNS4wMzMgNS40MjcgNS40MjcgMCAwIDEgLjU3NC0yLjUzNkM1LjM2NCAyLjQ3NCA3LjE0IDEuNTcgOS40IDEuNDM0Yy41OTMtLjAzNSAxLjAyMyAwIDEuNzczLjA3NS0uMDMtLjAxNC0uMS0uMDQ3LS4xNzEtLjA3NGE2LjYzNSA2LjYzNSAwIDAgMC0zLjMwOS0uMzY3IDYuNjkgNi42OSAwIDAgMC0xLjkxNS41ODRjLS4yNTQuMDktLjI5Mi0uMTI2LS40ODgtLjI5LS4wOTItLjA3Ni0uMDgzLjAyLS4wODMuMDIuMDguMzgxLS4wOTcuNTczLS4xMjQuNTkyYTIuMDc5IDIuMDc5IDAgMCAxLS40ODIuMzMyYy0uMzI2LjE0Mi0uNDc4LS4wOTItLjczNy0uMjI1LS4xNzgtLjA5LS4xMDguMDYtLjEwOC4wNi4yMi40MzcuMDY2LjgzOS4wMy45MDItLjE1Mi4yMi0uMjc4LjM3NS0uNDgzLjU2LS4zNTkuMzI1LS43ODUuMDEyLS45MTItLjAzNi0uMjQtLjA4OS0uMDY3LjExNS0uMDY3LjExNS4wOTYuMTI3LjQ0Ljg1Ni4zMzMgMS4wODZhNi43MzcgNi43MzcgMCAwIDAtLjUzOSA0LjE2NWMxIDUuMDA0IDYuNjg4IDYuNzQgMTAuMjI4IDQuMzIxIDEuODc5LTEuMzg3IDIuNTItMy41NDggMi41NC00Ljg5NS4wMjItMS4zNDctLjMxNy0yLjMyNy0uOTQyLTMuMjAxLTEuNDg0LTIuMDc0LTQuMTY4LTIuNzMyLTYuMzE0LTEuNzlaIi8+PC9zdmc+');
    _defineProperty(_assertThisInitialized(_this), "_loginState", void 0);
    _defineProperty(_assertThisInitialized(_this), "_wallet", void 0);
    _defineProperty(_assertThisInitialized(_this), "_config", void 0);
    _defineProperty(_assertThisInitialized(_this), "_sessionId", void 0);
    _defineProperty(_assertThisInitialized(_this), "_status", void 0);
    _defineProperty(_assertThisInitialized(_this), "_pin", void 0);
    /**
     * @deprecated use .onLoginComplete
     */
    _defineProperty(_assertThisInitialized(_this), "loginCompletely", _this.onLoginComplete);
    _this._loginState = LoginStateEnum.INITIAL;
    _this._wallet = null;
    _this._config = config;
    _this._sessionId = '';
    _this._pin = '';
    _this._status = 'initial';
    _this.autoRequestAccountHandler();
    return _this;
  }
  _createClass(PortkeyAAWallet, [{
    key: "setChainId",
    value: function setChainId(chainId) {
      this._config.chainId = chainId;
    }
  }, {
    key: "loginState",
    get: function get() {
      return this._loginState;
    }
  }, {
    key: "noNeedForConfirm",
    get: function get() {
      return this._config.noNeedForConfirm;
    }
  }, {
    key: "wallet",
    get: function get() {
      return this._wallet;
    }
  }, {
    key: "appName",
    get: function get() {
      var compatibleAppName = "V2-".concat(this._config.appName);
      if (enhancedLocalStorage.getItem(compatibleAppName)) {
        return compatibleAppName;
      } else {
        return this._config.appName;
      }
    }
  }, {
    key: "autoRequestAccountHandler",
    value: function () {
      var _autoRequestAccountHandler = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var canLoginEargly;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              canLoginEargly = !!enhancedLocalStorage.getItem(this._config.appName) || !!enhancedLocalStorage.getItem("V2-".concat(this._config.appName));
              if (canLoginEargly) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              if (this._config.autoShowUnlock) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              _context.next = 7;
              return this.loginEagerly();
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function autoRequestAccountHandler() {
        return _autoRequestAccountHandler.apply(this, arguments);
      }
      return autoRequestAccountHandler;
    }()
  }, {
    key: "loginWithAcceleration",
    value: function () {
      var _loginWithAcceleration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(createPendingInfo) {
        var didWallet;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              didWallet = createPendingInfo.didWallet;
              this._sessionId = createPendingInfo.sessionId;
              this._status = createPendingInfo.sessionId === 'tmp_beforeLastGuardianApprove' ? 'inBeforeLastGuardianApprove' : 'inCreatePending';
              this._pin = createPendingInfo.pin;
              return _context2.abrupt("return", this.login(didWallet));
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function loginWithAcceleration(_x) {
        return _loginWithAcceleration.apply(this, arguments);
      }
      return loginWithAcceleration;
    }()
  }, {
    key: "onLoginComplete",
    value: function () {
      var _onLoginComplete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _did$didWallet$isLogi;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              try {
                this._status = 'inFinish';
                this.emit('loginOnChainStatusChanged', (_did$didWallet$isLogi = did.didWallet.isLoginStatus) !== null && _did$didWallet$isLogi !== void 0 ? _did$didWallet$isLogi : LoginStatusEnum.INIT);
              } catch (error) {
                this.emit('error', makeError(ERR_CODE.ONFINISH_IS_ERROR, error));
              }
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function onLoginComplete() {
        return _onLoginComplete.apply(this, arguments);
      }
      return onLoginComplete;
    }()
  }, {
    key: "login",
    value: function () {
      var _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(didWalletInfo) {
        var _didWalletInfo$caInfo2, _didWalletInfo$caInfo3, _didWalletInfo$wallet, chainId, enableAcceleration, _didWalletInfo$caInfo, caInfo, nickName, holderInfo, portkeyInfo;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              enhancedLocalStorage.setItem(PORTKEY_ORIGIN_CHAIN_ID_KEY, didWalletInfo.chainId);
              this._loginState = LoginStateEnum.CONNECTING;
              chainId = this._config.chainId;
              enableAcceleration = this._config.enableAcceleration;
              if (!(didWalletInfo.chainId !== chainId)) {
                _context4.next = 10;
                break;
              }
              _context4.next = 8;
              return did.didWallet.getHolderInfoByContract({
                caHash: (_didWalletInfo$caInfo = didWalletInfo.caInfo) === null || _didWalletInfo$caInfo === void 0 ? void 0 : _didWalletInfo$caInfo.caHash,
                chainId: chainId
              });
            case 8:
              caInfo = _context4.sent;
              didWalletInfo.caInfo.caAddress = caInfo === null || caInfo === void 0 ? void 0 : caInfo.caAddress;
            case 10:
              nickName = 'Wallet 01';
              if (!(enableAcceleration && this._status !== 'inBeforeLastGuardianApprove')) {
                _context4.next = 21;
                break;
              }
              _context4.prev = 12;
              _context4.next = 15;
              return did.getCAHolderInfo(didWalletInfo.chainId);
            case 15:
              holderInfo = _context4.sent;
              nickName = holderInfo.nickName;
              _context4.next = 21;
              break;
            case 19:
              _context4.prev = 19;
              _context4.t0 = _context4["catch"](12);
            case 21:
              _context4.prev = 21;
              _context4.next = 24;
              return did.save(didWalletInfo.pin, this.appName);
            case 24:
              _context4.next = 29;
              break;
            case 26:
              _context4.prev = 26;
              _context4.t1 = _context4["catch"](21);
              throw _context4.t1;
            case 29:
              portkeyInfo = _objectSpread(_objectSpread({}, didWalletInfo), {}, {
                accounts: _defineProperty({}, chainId, (_didWalletInfo$caInfo2 = didWalletInfo.caInfo) === null || _didWalletInfo$caInfo2 === void 0 ? void 0 : _didWalletInfo$caInfo2.caAddress),
                nickName: nickName,
                pin: this._pin,
                appName: this.appName
              });
              this._wallet = {
                name: nickName,
                address: (_didWalletInfo$caInfo3 = didWalletInfo.caInfo) === null || _didWalletInfo$caInfo3 === void 0 ? void 0 : _didWalletInfo$caInfo3.caAddress,
                extraInfo: {
                  publicKey: (didWalletInfo === null || didWalletInfo === void 0 || (_didWalletInfo$wallet = didWalletInfo.walletInfo) === null || _didWalletInfo$wallet === void 0 || (_didWalletInfo$wallet = _didWalletInfo$wallet.keyPair) === null || _didWalletInfo$wallet === void 0 ? void 0 : _didWalletInfo$wallet.getPublic('hex')) || '',
                  portkeyInfo: portkeyInfo
                }
              };
              this._loginState = LoginStateEnum.CONNECTED;
              enhancedLocalStorage.setItem(ConnectedWallet, this.name);
              if (!this._sessionId) {
                this._status = 'inFinish';
              }
              this.emit('connected', this._wallet);
              this.emit('loginOnChainStatusChanged', did.didWallet.isLoginStatus);
              return _context4.abrupt("return", this._wallet);
            case 39:
              _context4.prev = 39;
              _context4.t2 = _context4["catch"](0);
              this._loginState = LoginStateEnum.INITIAL;
              this.emit('error', makeError(ERR_CODE.PORTKEY_AA_LOGIN_FAIL, _context4.t2));
              return _context4.abrupt("return");
            case 44:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 39], [12, 19], [21, 26]]);
      }));
      function login(_x2) {
        return _login.apply(this, arguments);
      }
      return login;
    }() // TODO: will be execute emit first, then execute onLockHandler, Set a delay first and optimize later
  }, {
    key: "loginEagerly",
    value: function () {
      var _loginEagerly = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this2 = this;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              setTimeout(function () {
                _this2.emit('lock');
              }, 1000);
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function loginEagerly() {
        return _loginEagerly.apply(this, arguments);
      }
      return loginEagerly;
    }()
  }, {
    key: "lock",
    value: function lock() {
      if (!this._wallet) {
        throw makeError(ERR_CODE.PORTKEY_AA_NOT_CONNECTED);
      }
      did.reset();
      this._status = 'initial';
      this._wallet = null;
      this._loginState = LoginStateEnum.INITIAL;
      this.emit('disconnected', true);
    }
  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var isForgetPin,
          originChainId,
          _args6 = arguments;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              isForgetPin = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : false;
              _context6.prev = 1;
              originChainId = enhancedLocalStorage.getItem(PORTKEY_ORIGIN_CHAIN_ID_KEY);
              if (originChainId) {
                _context6.next = 5;
                break;
              }
              return _context6.abrupt("return");
            case 5:
              if (isForgetPin) {
                _context6.next = 8;
                break;
              }
              _context6.next = 8;
              return did.logout({
                chainId: originChainId
              }, {
                onMethod: 'transactionHash'
              });
            case 8:
              this._wallet = null;
              this._loginState = LoginStateEnum.INITIAL;
              enhancedLocalStorage.removeItem(ConnectedWallet);
              enhancedLocalStorage.removeItem(PORTKEY_ORIGIN_CHAIN_ID_KEY);
              enhancedLocalStorage.removeItem(this.appName);
              this.emit('disconnected');
              _context6.next = 19;
              break;
            case 16:
              _context6.prev = 16;
              _context6.t0 = _context6["catch"](1);
              this.emit('error', makeError(ERR_CODE.PORTKEY_AA_LOGOUT_FAIL, _context6.t0));
            case 19:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[1, 16]]);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }()
  }, {
    key: "checkPassword",
    value: function () {
      var _checkPassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(keyName, password) {
        var aesStr;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return did.didWallet._storage.getItem(keyName || did.didWallet._defaultKeyName);
            case 3:
              aesStr = _context7.sent;
              if (!aesStr) {
                _context7.next = 6;
                break;
              }
              return _context7.abrupt("return", !!aes.decrypt(aesStr, password));
            case 6:
              _context7.next = 11;
              break;
            case 8:
              _context7.prev = 8;
              _context7.t0 = _context7["catch"](0);
              return _context7.abrupt("return", false);
            case 11:
              return _context7.abrupt("return", false);
            case 12:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[0, 8]]);
      }));
      function checkPassword(_x3, _x4) {
        return _checkPassword.apply(this, arguments);
      }
      return checkPassword;
    }()
  }, {
    key: "onUnlock",
    value: function () {
      var _onUnlock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(password) {
        var _caInfo, _didWalletInfo$caInfo4, _didWalletInfo$caInfo5, _did$didWallet$isLogi2, appName, chainId, isValidPinCode, localWallet, caInfo, caHash, key, originChainId, nickName, holderInfo, _localWallet$didWalle, _localWallet$didWalle2, result, _yield$did$didWallet$, recoveryStatus, didWalletInfo, portkeyInfo;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              appName = this.appName;
              chainId = this._config.chainId;
              _context8.next = 5;
              return this.checkPassword(appName, password);
            case 5:
              isValidPinCode = _context8.sent;
              if (isValidPinCode) {
                _context8.next = 8;
                break;
              }
              return _context8.abrupt("return");
            case 8:
              _context8.next = 10;
              return did.load(password, appName);
            case 10:
              localWallet = _context8.sent;
              caInfo = localWallet.didWallet.caInfo[chainId];
              caHash = (_caInfo = caInfo) === null || _caInfo === void 0 ? void 0 : _caInfo.caHash;
              if (caInfo) {
                _context8.next = 19;
                break;
              }
              key = Object.keys(localWallet.didWallet.caInfo)[0];
              caHash = localWallet.didWallet.caInfo[key].caHash;
              _context8.next = 18;
              return did.didWallet.getHolderInfoByContract({
                caHash: caHash,
                chainId: chainId
              });
            case 18:
              caInfo = _context8.sent;
            case 19:
              originChainId = enhancedLocalStorage.getItem(PORTKEY_ORIGIN_CHAIN_ID_KEY);
              nickName = localWallet.didWallet.accountInfo.nickName || 'Wallet 01';
              if (!originChainId) {
                _context8.next = 26;
                break;
              }
              _context8.next = 24;
              return did.getCAHolderInfo(originChainId);
            case 24:
              holderInfo = _context8.sent;
              nickName = holderInfo.nickName;
            case 26:
              if (!(did.didWallet.isLoginStatus !== LoginStatusEnum.SUCCESS)) {
                _context8.next = 45;
                break;
              }
              if (localWallet.didWallet.sessionId) {
                _context8.next = 38;
                break;
              }
              _context8.next = 30;
              return did.didWallet.checkManagerIsExistByGQL({
                chainId: originChainId,
                caHash: caHash,
                managementAddress: (_localWallet$didWalle = (_localWallet$didWalle2 = localWallet.didWallet.managementAccount) === null || _localWallet$didWalle2 === void 0 ? void 0 : _localWallet$didWalle2.address) !== null && _localWallet$didWalle !== void 0 ? _localWallet$didWalle : ''
              });
            case 30:
              result = _context8.sent;
              if (!result) {
                _context8.next = 36;
                break;
              }
              _context8.next = 34;
              return did.save(password, this.appName);
            case 34:
              _context8.next = 36;
              break;
            case 36:
              _context8.next = 45;
              break;
            case 38:
              _context8.next = 40;
              return did.didWallet.getLoginStatus({
                sessionId: did.didWallet.sessionId,
                chainId: did.didWallet.originChainId
              });
            case 40:
              _yield$did$didWallet$ = _context8.sent;
              recoveryStatus = _yield$did$didWallet$.recoveryStatus;
              if (!(recoveryStatus === 'pass')) {
                _context8.next = 45;
                break;
              }
              _context8.next = 45;
              return did.save(password, this.appName);
            case 45:
              didWalletInfo = {
                caInfo: caInfo,
                pin: password,
                chainId: originChainId,
                walletInfo: localWallet.didWallet.managementAccount.wallet,
                accountInfo: localWallet.didWallet.accountInfo,
                createType: 'recovery'
              };
              portkeyInfo = _objectSpread(_objectSpread({}, didWalletInfo), {}, {
                accounts: _defineProperty({}, chainId, (_didWalletInfo$caInfo4 = didWalletInfo.caInfo) === null || _didWalletInfo$caInfo4 === void 0 ? void 0 : _didWalletInfo$caInfo4.caAddress),
                nickName: nickName
              });
              this._wallet = {
                name: nickName,
                address: (_didWalletInfo$caInfo5 = didWalletInfo.caInfo) === null || _didWalletInfo$caInfo5 === void 0 ? void 0 : _didWalletInfo$caInfo5.caAddress,
                extraInfo: {
                  publicKey: (didWalletInfo === null || didWalletInfo === void 0 ? void 0 : didWalletInfo.walletInfo.keyPair.getPublic('hex')) || '',
                  portkeyInfo: portkeyInfo
                }
              };
              this._loginState = LoginStateEnum.CONNECTED;
              enhancedLocalStorage.setItem(ConnectedWallet, this.name);
              this._status = 'inFinish';
              this.emit('connected', this._wallet);
              this.emit('loginOnChainStatusChanged', (_did$didWallet$isLogi2 = did.didWallet.isLoginStatus) !== null && _did$didWallet$isLogi2 !== void 0 ? _did$didWallet$isLogi2 : LoginStatusEnum.INIT);
              return _context8.abrupt("return", this._wallet);
            case 56:
              _context8.prev = 56;
              _context8.t0 = _context8["catch"](0);
              this._loginState = LoginStateEnum.INITIAL;
              this.emit('error', makeError(ERR_CODE.PORTKEY_AA_UNLOCK_FAIL, _context8.t0));
              return _context8.abrupt("return");
            case 61:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[0, 56]]);
      }));
      function onUnlock(_x5) {
        return _onUnlock.apply(this, arguments);
      }
      return onUnlock;
    }()
  }, {
    key: "getSignature",
    value: function () {
      var _getSignature = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(params) {
        var signInfo, signature;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (params.hexToBeSign) {
                console.error('getSignature: hexToBeSign is deprecated, please use signInfo instead, signInfo is utf-8 string not hex');
              }
              if (this._wallet) {
                _context9.next = 3;
                break;
              }
              throw makeError(ERR_CODE.PORTKEY_AA_NOT_CONNECTED);
            case 3:
              signInfo = '';
              if (params.hexToBeSign) {
                signInfo = params.hexToBeSign;
              } else {
                signInfo = params.signInfo;
              }
              signature = did.sign(signInfo).toString('hex');
              return _context9.abrupt("return", {
                error: 0,
                errorMessage: '',
                signature: signature,
                from: 'portkey'
              });
            case 7:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function getSignature(_x6) {
        return _getSignature.apply(this, arguments);
      }
      return getSignature;
    }()
  }, {
    key: "getAccountByChainId",
    value: function () {
      var _getAccountByChainId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(chainId) {
        var _this$_wallet;
        var accounts, _this$_wallet2, caInfo;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              if (this._wallet) {
                _context10.next = 2;
                break;
              }
              throw makeError(ERR_CODE.PORTKEY_AA_NOT_CONNECTED);
            case 2:
              accounts = (_this$_wallet = this._wallet) === null || _this$_wallet === void 0 || (_this$_wallet = _this$_wallet.extraInfo) === null || _this$_wallet === void 0 ? void 0 : _this$_wallet.portkeyInfo.accounts;
              if (!(!accounts || !accounts[chainId])) {
                _context10.next = 8;
                break;
              }
              _context10.next = 6;
              return did.didWallet.getHolderInfoByContract({
                caHash: (_this$_wallet2 = this._wallet) === null || _this$_wallet2 === void 0 || (_this$_wallet2 = _this$_wallet2.extraInfo) === null || _this$_wallet2 === void 0 || (_this$_wallet2 = _this$_wallet2.portkeyInfo) === null || _this$_wallet2 === void 0 || (_this$_wallet2 = _this$_wallet2.caInfo) === null || _this$_wallet2 === void 0 ? void 0 : _this$_wallet2.caHash,
                chainId: chainId
              });
            case 6:
              caInfo = _context10.sent;
              return _context10.abrupt("return", caInfo === null || caInfo === void 0 ? void 0 : caInfo.caAddress);
            case 8:
              return _context10.abrupt("return", accounts[chainId]);
            case 9:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function getAccountByChainId(_x7) {
        return _getAccountByChainId.apply(this, arguments);
      }
      return getAccountByChainId;
    }()
  }, {
    key: "getWalletSyncIsCompleted",
    value: function () {
      var _getWalletSyncIsCompleted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(chainId) {
        var _this$_wallet$extraIn, _didWalletInfo$caInfo6, _didWalletInfo$wallet2;
        var didWalletInfo, caHash, address, originChainId, _this$_wallet$address, holder, filteredHolders, _this$_wallet$address2;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              if (this._wallet) {
                _context11.next = 2;
                break;
              }
              throw makeError(ERR_CODE.PORTKEY_AA_NOT_CONNECTED);
            case 2:
              didWalletInfo = (_this$_wallet$extraIn = this._wallet.extraInfo) === null || _this$_wallet$extraIn === void 0 ? void 0 : _this$_wallet$extraIn.portkeyInfo;
              caHash = didWalletInfo === null || didWalletInfo === void 0 || (_didWalletInfo$caInfo6 = didWalletInfo.caInfo) === null || _didWalletInfo$caInfo6 === void 0 ? void 0 : _didWalletInfo$caInfo6.caHash;
              address = didWalletInfo === null || didWalletInfo === void 0 || (_didWalletInfo$wallet2 = didWalletInfo.walletInfo) === null || _didWalletInfo$wallet2 === void 0 ? void 0 : _didWalletInfo$wallet2.address;
              originChainId = didWalletInfo === null || didWalletInfo === void 0 ? void 0 : didWalletInfo.chainId;
              if (!(originChainId === chainId)) {
                _context11.next = 8;
                break;
              }
              return _context11.abrupt("return", (_this$_wallet$address = this._wallet.address) !== null && _this$_wallet$address !== void 0 ? _this$_wallet$address : false);
            case 8:
              _context11.prev = 8;
              _context11.next = 11;
              return did.didWallet.getHolderInfoByContract({
                chainId: chainId,
                caHash: caHash
              });
            case 11:
              holder = _context11.sent;
              filteredHolders = holder.managerInfos.filter(function (manager) {
                return (manager === null || manager === void 0 ? void 0 : manager.address) === address;
              });
              if (!filteredHolders.length) {
                _context11.next = 17;
                break;
              }
              return _context11.abrupt("return", (_this$_wallet$address2 = this._wallet.address) !== null && _this$_wallet$address2 !== void 0 ? _this$_wallet$address2 : false);
            case 17:
              return _context11.abrupt("return", false);
            case 18:
              _context11.next = 23;
              break;
            case 20:
              _context11.prev = 20;
              _context11.t0 = _context11["catch"](8);
              return _context11.abrupt("return", false);
            case 23:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this, [[8, 20]]);
      }));
      function getWalletSyncIsCompleted(_x8) {
        return _getWalletSyncIsCompleted.apply(this, arguments);
      }
      return getWalletSyncIsCompleted;
    }()
  }, {
    key: "getUrl",
    value: function getUrl() {
      return new URL(location.href);
    }
  }, {
    key: "getFaviconUrl",
    value: function getFaviconUrl(url) {
      var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
      var hostUrl = new URL(url).host;
      return "https://icon.horse/icon/".concat(hostUrl, "/").concat(size);
    }
  }, {
    key: "sendAdapter",
    value: function () {
      var _sendAdapter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(_ref) {
        var _extraInfo;
        var caContract, chainId, contractAddress, methodName, args, sendOptions, _ref$guardiansApprove, guardiansApproved, didWalletInfo, chainInfo, _didWalletInfo$caInfo7, _didWalletInfo$caInfo8, _this$getUrl, origin, href, name, icon, originChainId, _ref2, amount, _guardiansApproved, symbol, _didWalletInfo$caInfo9, params;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              caContract = _ref.caContract, chainId = _ref.chainId, contractAddress = _ref.contractAddress, methodName = _ref.methodName, args = _ref.args, sendOptions = _ref.sendOptions, _ref$guardiansApprove = _ref.guardiansApproved, guardiansApproved = _ref$guardiansApprove === void 0 ? [] : _ref$guardiansApprove;
              didWalletInfo = (_extraInfo = this._wallet.extraInfo) === null || _extraInfo === void 0 ? void 0 : _extraInfo.portkeyInfo;
              _context12.next = 4;
              return getChain(chainId);
            case 4:
              chainInfo = _context12.sent;
              if (!((contractAddress === (chainInfo === null || chainInfo === void 0 ? void 0 : chainInfo.defaultToken.address) && methodName) === 'Approve')) {
                _context12.next = 18;
                break;
              }
              _this$getUrl = this.getUrl(), origin = _this$getUrl.origin, href = _this$getUrl.href, name = _this$getUrl.hostname;
              icon = this.getFaviconUrl(href);
              originChainId = didWalletInfo.chainId; // use amount from result of managerApprove not from params
              // dapp user may change amount at pop-up
              _context12.next = 11;
              return managerApprove(_objectSpread(_objectSpread({
                originChainId: originChainId,
                targetChainId: chainId,
                caHash: (_didWalletInfo$caInfo7 = didWalletInfo.caInfo) === null || _didWalletInfo$caInfo7 === void 0 ? void 0 : _didWalletInfo$caInfo7.caHash
              }, args), {}, {
                dappInfo: {
                  icon: icon,
                  href: origin,
                  name: name
                }
              }));
            case 11:
              _ref2 = _context12.sent;
              amount = _ref2.amount;
              _guardiansApproved = _ref2.guardiansApproved;
              symbol = _ref2.symbol;
              return _context12.abrupt("return", caContract.callSendMethod('ManagerApprove', '', _objectSpread(_objectSpread({
                caHash: (_didWalletInfo$caInfo8 = didWalletInfo.caInfo) === null || _didWalletInfo$caInfo8 === void 0 ? void 0 : _didWalletInfo$caInfo8.caHash
              }, args), {}, {
                guardiansApproved: _guardiansApproved,
                amount: amount,
                symbol: symbol
              }), sendOptions));
            case 18:
              params = {
                guardiansApproved: guardiansApproved,
                caHash: (_didWalletInfo$caInfo9 = didWalletInfo.caInfo) === null || _didWalletInfo$caInfo9 === void 0 ? void 0 : _didWalletInfo$caInfo9.caHash,
                contractAddress: contractAddress,
                methodName: methodName,
                args: args
              };
              return _context12.abrupt("return", caContract.callSendMethod('ManagerForwardCall', didWalletInfo.walletInfo.address, params, sendOptions));
            case 20:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function sendAdapter(_x9) {
        return _sendAdapter.apply(this, arguments);
      }
      return sendAdapter;
    }()
  }, {
    key: "getContract",
    value: function () {
      var _getContract = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(chainId, contractAddress) {
        var _this$_wallet$extraIn2;
        var chainsInfo, chainInfo;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              if (this._wallet) {
                _context13.next = 2;
                break;
              }
              throw makeError(ERR_CODE.PORTKEY_AA_NOT_CONNECTED);
            case 2:
              _context13.next = 4;
              return did.services.getChainsInfo();
            case 4:
              chainsInfo = _context13.sent;
              chainInfo = chainsInfo.find(function (chain) {
                return chain.chainId === chainId;
              });
              if (chainInfo) {
                _context13.next = 8;
                break;
              }
              throw new Error("chain is not running: ".concat(chainId));
            case 8:
              return _context13.abrupt("return", getContractBasic({
                contractAddress: contractAddress || chainInfo.caContractAddress,
                account: (_this$_wallet$extraIn2 = this._wallet.extraInfo) === null || _this$_wallet$extraIn2 === void 0 ? void 0 : _this$_wallet$extraIn2.portkeyInfo.walletInfo,
                rpcUrl: chainInfo.endPoint
              }));
            case 9:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function getContract(_x10, _x11) {
        return _getContract.apply(this, arguments);
      }
      return getContract;
    }()
  }, {
    key: "callSendMethod",
    value: function () {
      var _callSendMethod = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(_ref3) {
        var chainId, contractAddress, methodName, args, sendOptions, _ref3$guardiansApprov, guardiansApproved, enableAcceleration, _yield$did$didWallet$2, recoveryStatus, finalChainId, contract, rs, _extraInfo2, _didWalletInfo$caInfo10, didWalletInfo, adapterProps;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              chainId = _ref3.chainId, contractAddress = _ref3.contractAddress, methodName = _ref3.methodName, args = _ref3.args, sendOptions = _ref3.sendOptions, _ref3$guardiansApprov = _ref3.guardiansApproved, guardiansApproved = _ref3$guardiansApprov === void 0 ? [] : _ref3$guardiansApprov;
              enableAcceleration = this._config.enableAcceleration;
              if (this._wallet) {
                _context14.next = 4;
                break;
              }
              throw makeError(ERR_CODE.PORTKEY_AA_NOT_CONNECTED);
            case 4:
              if (contractAddress) {
                _context14.next = 6;
                break;
              }
              throw makeError(ERR_CODE.INVALID_CONTRACT_ADDRESS);
            case 6:
              if (!(enableAcceleration && (this._status === 'initial' || this._status === 'inBeforeLastGuardianApprove'))) {
                _context14.next = 8;
                break;
              }
              throw makeError(ERR_CODE.CANT_CALL_SEND_METHOD);
            case 8:
              if (!(enableAcceleration && this._status === 'inCreatePending')) {
                _context14.next = 17;
                break;
              }
              _context14.next = 11;
              return did.didWallet.getLoginStatus({
                sessionId: did.didWallet.sessionId,
                chainId: did.didWallet.originChainId
              });
            case 11:
              _yield$did$didWallet$2 = _context14.sent;
              recoveryStatus = _yield$did$didWallet$2.recoveryStatus;
              _context14.next = 15;
              return did.save(this._pin, this.appName);
            case 15:
              if (!(recoveryStatus !== 'pass')) {
                _context14.next = 17;
                break;
              }
              throw makeError(ERR_CODE.GET_LOGIN_STATUS_FAIL);
            case 17:
              // if (this._status === 'inFinish' && did.didWallet.isLoginStatus !== 'SUCCESS') {
              //   throw makeError(ERR_CODE.IN_FINISH_BUT_STATUS_IS_NOT_SUCCESS);
              // }
              finalChainId = chainId || this._config.chainId;
              _context14.next = 20;
              return this.getContract(finalChainId);
            case 20:
              contract = _context14.sent;
              if (!(methodName === 'RemoveReadOnlyManager')) {
                _context14.next = 28;
                break;
              }
              didWalletInfo = (_extraInfo2 = this._wallet.extraInfo) === null || _extraInfo2 === void 0 ? void 0 : _extraInfo2.portkeyInfo;
              _context14.next = 25;
              return contract.callSendMethod('RemoveReadOnlyManager', (_didWalletInfo$caInfo10 = didWalletInfo.caInfo) === null || _didWalletInfo$caInfo10 === void 0 ? void 0 : _didWalletInfo$caInfo10.caAddress, args);
            case 25:
              rs = _context14.sent;
              _context14.next = 32;
              break;
            case 28:
              adapterProps = {
                guardiansApproved: guardiansApproved,
                caContract: contract,
                chainId: finalChainId,
                contractAddress: contractAddress,
                methodName: methodName,
                args: args,
                sendOptions: sendOptions
              };
              _context14.next = 31;
              return this.sendAdapter(adapterProps);
            case 31:
              rs = _context14.sent;
            case 32:
              return _context14.abrupt("return", rs);
            case 33:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function callSendMethod(_x12) {
        return _callSendMethod.apply(this, arguments);
      }
      return callSendMethod;
    }()
  }, {
    key: "callViewMethod",
    value: function () {
      var _callViewMethod = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(_ref4) {
        var chainId, contractAddress, methodName, args, finalChainId, contract, rs;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              chainId = _ref4.chainId, contractAddress = _ref4.contractAddress, methodName = _ref4.methodName, args = _ref4.args;
              if (this._wallet) {
                _context15.next = 3;
                break;
              }
              throw makeError(ERR_CODE.PORTKEY_AA_NOT_CONNECTED);
            case 3:
              if (contractAddress) {
                _context15.next = 5;
                break;
              }
              throw makeError(ERR_CODE.INVALID_CONTRACT_ADDRESS);
            case 5:
              finalChainId = chainId || this._config.chainId;
              _context15.next = 8;
              return this.getContract(finalChainId, contractAddress);
            case 8:
              contract = _context15.sent;
              rs = contract.callViewMethod(methodName, args);
              return _context15.abrupt("return", rs);
            case 11:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function callViewMethod(_x13) {
        return _callViewMethod.apply(this, arguments);
      }
      return callViewMethod;
    }()
  }, {
    key: "sendMultiTransaction",
    value: function () {
      var _sendMultiTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(params) {
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              return _context16.abrupt("return", did.sendMultiTransaction(params));
            case 1:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }));
      function sendMultiTransaction(_x14) {
        return _sendMultiTransaction.apply(this, arguments);
      }
      return sendMultiTransaction;
    }()
  }]);
  return PortkeyAAWallet;
}(BaseWalletAdapter);